import api from "services/api";

import { IWebProfileFormData } from "../interfaces";

export const HandlePasswordChange = async (
  webProfileFormData
: IWebProfileFormData) => {
  const passwordFormData = {
    password: webProfileFormData?.password,
    password_confirmation: webProfileFormData?.password,
    old_password: webProfileFormData?.old_password
  }

  try {
    await api.patch('/users/password', passwordFormData)

    return Promise.resolve()
  } catch (error: any) {
    return Promise.reject(error);
  }
}
